import $ from 'jquery';
import { getUser } from '~src/user';
import { modifyState } from '~src/state';
import { showAfIntroModal } from '~src/sidebar/annunciFunebri/showAfIntroModal';
import triggerChatFlow from '~src/utils/triggerChatFlow';

export const initAnnunciFunebri = async () => {
  $('body').off('click', '#navbar-private-af-logo', showAfIntroModal);
  $('body').on('click', '#navbar-private-af-logo', showAfIntroModal);
  const { user } = await getUser();
  if (user.org_pointer.integrazione_annunci_funebri) {
    modifyState('af_enabled', true);
  } else {
    modifyState('af_enabled', false);
  }

  $('body').on(
    'click',
    '[data-tracking-annuncifunebri-create-cordogli-start-chat]',
    () => {
      triggerChatFlow(
        'Salve, vorrei maggiori informazioni su AnnunciFunebri.it. Potete contattarmi? Recapito e disponibilità: '
      );
    }
  );
};
